import * as Yup from 'yup';

const vehicleSchema = Yup.object({
  reg: Yup.string()
    .label('Rekisterinumero')
    .required(),
  identifier: Yup.string()
    .label('Tunniste')
    .required(),
  customer_id: Yup.number()
    .label('Omistaja')
    .required(),
  traffic_id: Yup.number()
    .label('Kuorma')
    .required(),
  vehicle_type_id: Yup.string()
    .label('Ajoneuvotyyppi')
    .required(),
  axles_enabled: Yup.boolean().default(false)
});

export default vehicleSchema;
export type VehicleSchema = ReturnType<typeof vehicleSchema.cast>;
